import { dispatch } from "hf-rt";
import { HOST_URL, ROOT } from "../constants";
import { stringify } from "qs";
import { searchKeywords, loading } from "../models";
import getCookie from "../function/getCookie";

const initialState = {
  activeSortBy: {
    name: "關聯性",
    name_en: "Relevance",
    sortBy: "",
    sortDirection: ""
  },
  sortByLists: [
    {
      name: "關聯性",
      name_en: "Relevance",
      sortBy: "",
      sortDirection: ""
    },
    {
      name: "最新上架",
      name_en: "New to EMPHASIS",
      sortBy: "onlineFrom",
      sortDirection: "desc"
    },
    {
      name: "由價格高至低",
      name_en: "Price from High to Low",
      sortBy: "originalPrice",
      sortDirection: "desc"
    },
    {
      name: "由價格低至高",
      name_en: "Price from Low to High",
      sortBy: "originalPrice",
      sortDirection: "asc"
    }
  ]
};

export default {
  name: "sortByFilter",
  actions: {
    updateSortBy: async function (
      data,
      keywords,
      chosenFilterList,
      changeUrl = false
    ) {
      dispatch({ type: "UPDATE_SORT_BY", data });
      // 顯示載入畫面
      loading.actions.startLoading(true);
      // 資料清空
      // searchKeywords.actions.updateSearchResult(null, []);
      const criteriaCode = chosenFilterList.map(data => data.code).join(",");
      const params2 =
        criteriaCode !== ""
          ? {
              searchText: keywords,
              page: 1,
              criteriaCode: criteriaCode,
              sortBy: data.sortBy,
              sortDirection: data.sortDirection
            }
          : {
              searchText: keywords,
              page: 1,
              sortBy: data.sortBy,
              sortDirection: data.sortDirection
            };
      const params =
        data.sortBy === ""
          ? criteriaCode !== ""
            ? {
                searchText: keywords,
                page: 1,
                criteriaCode: criteriaCode
              }
            : {
                searchText: keywords,
                page: 1
              }
          : params2;
      const textParams = stringify(params);
      const url = `${HOST_URL}/shopping/v1/catalogItemSearches/search?${textParams}`;
      if (changeUrl) {
        const pathLang =
          getCookie("hk-emphasis-language") === "en" ? "en" : "tc";
        window.history.pushState(
          null,
          null,
          `${ROOT}/${pathLang}/search?${textParams}`
        );
      }
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include"
        });
        if (response.status === 200) {
          const data = await response.json();
          const searchProductList = data.productRefinements[0].productList;
          if (data.productRefinements[0].productList.length === 0) {
            console.log("**no result, keyword:" + textParams);
          }

          // 載入新的資訊、商品
          searchKeywords.actions.updateSearchResult(
            data.productRefinements[0],
            searchProductList
          );
          // 更新頁面回第一頁
          searchKeywords.actions.updatePage(1);
        } else {
          searchKeywords.actions.updateSearchResult(null, []);
          throw new Error("search error");
        }
      } catch (error) {
        console.log(error);
      } finally {
        loading.actions.startLoading(false);
      }
    }
  },
  reducers: function (state = initialState, action) {
    switch (action.type) {
      case "UPDATE_SORT_BY":
        return {
          ...state,
          activeSortBy: action.data
        };
      default:
        return state;
    }
  }
};
